import { loadSourceData } from './sourceApi'
import { SYSTEM_TYPE } from '@/app/store/systemStore'
import { getSessionAbortSignal } from './sessionAbortController'

const STALE_TIME = 5 * 60 * 1000

export const buildEntityQuery = <T>(
  entity: string,
  authParam: string | null,
  sourceApiUrl: string,
  systemUrl: string,
  systemType: SYSTEM_TYPE,
  queryKeyPrefix: string
) => ({
  queryKey: [queryKeyPrefix, entity, authParam, systemUrl] as const,
  queryFn: () =>
    loadSourceData<T>(
      entity,
      authParam!,
      sourceApiUrl,
      systemUrl,
      systemType,
      getSessionAbortSignal()
    ),
  enabled: !!authParam,
  staleTime: STALE_TIME,
})
